// extracted by mini-css-extract-plugin
export default {"mainContainer":"PrivacyPolicy_mainContainer__-Jt-7"};